import React, { lazy, Suspense }  from 'react';
import DashboardTab from '../DashBoard/DashBoardTab';
import AboutPageBody from './AboutPageBody';
import AuthSettings from '../Auth/AuthSettings';
import OtherServiceChannels from '../Modal/OtherService';
import AdsModal from '../Modal/AdsModal';


const ShopAll = lazy(() => import('../DropDown/ShopAll'));
const ModalMenu = lazy(() => import('../Modal/ModalMenu'));
const SearchBarBS = lazy(() => import('../SearchBar/SearchBarBS'));
const SearchBarSS = lazy(() => import('../SearchBar/SearchBarSS'));
const OnDemand = lazy(() => import('../DropDown/OnDemand'));
const Recommended = lazy(() => import('../DropDown/Recommended'));
const OurLocations = lazy(() => import('../DropDown/Ourlocations'));
const ContactUs = lazy(() => import('../Contact/ContactUs'));
const Footer = lazy(() => import('../Footer/Footer'));

export default () => (
  <div className='dashboard'>
    <Suspense fallback={<p>Loading...</p>}>
      <ModalMenu />
      <OtherServiceChannels />
      <SearchBarBS />
      <SearchBarSS />
    </Suspense>
    <DashboardTab />
    <AuthSettings />
    <AdsModal />
    <Suspense fallback={<p>Loading...</p>}>
    <ShopAll />
      <OnDemand />
      <Recommended />
      <OurLocations />
      <ContactUs />
    </Suspense>
    <AboutPageBody />
    <Suspense fallback={<p>Loading...</p>}>
      <Footer />
    </Suspense>
  </div>
);
